<template>
  <div>
    <!-- <itemfile-loader></itemfile-loader> -->
    <div class="head-wrap clear">
      <div class="fl">
        <img class="sys-title" src="../../../static/images/head/标题-玛纳斯.png" alt />
        <!--<img class="sys-title" src="../../../static/images/head/十师.png" alt="">-->
      </div>
      <div class="fl">
        <nav-head :userInFo="userInfo"></nav-head>
      </div>
      <div class="fl">
        <span style="margin: 17px 10px 0 300px;display: block;font-size: 30px;font-weight: bold;color: yellow;">禁止处理国家秘密及工作秘密</span>
      </div>
      <div class="fr" style="height:70px;line-height:70px">
        <div class="head-cells fl" @click="showAlarm">
          <el-badge :value="alarmListX.length" class="item">
            <img style="top:-23px" src="../../../static/images/head/alarm.png" />
            <p style="top:5px;margin-right:-33px;" class="head-text">报警</p>
          </el-badge>
        </div>

        <div class="head-cell fl" @click="userinfoVisible = true">
          <img src="../../../static/images/head/超级管理员.png" />
          <p class="head-text">{{userInfo.name}}</p>
        </div>
        <div class="head-cells fl" @click="exitSys()">
          <img src="../../../static/images/head/退出.png" />
          <p class="head-text">退出</p>
        </div>
      </div>
      <!--<div class="choose_information" @mouseleave="leave" @mouseenter="enter" v-show="isTrue">
            	<ul>
            		<li @click="userinfoVisible = true">用户信息</li>
            		<li @click="exitSys()">退出</li>
            	</ul>
      </div>-->
    </div>
    <el-dialog title="用户信息" :visible.sync="userinfoVisible" width="500px">
      <div class="infodia clear">
        <div class="infodia-cell fl">
          <label>姓名：</label>
          <span>{{userInfo.name}}</span>
        </div>
        <div class="infodia-cell fl">
          <label>性别：</label>
          <span>{{userInfo.sex}}</span>
        </div>
        <div class="infodia-cell fl">
          <label>职称：</label>
          <span>{{userInfo.position}}</span>
        </div>
        <div class="infodia-cell fl">
          <label>部门：</label>
          <span></span>
        </div>
        <div class="infodia-cell fl">
          <label>单位：</label>
          <span></span>
        </div>
        <div class="infodia-cell fl">
          <label>角色：</label>
          <span>{{userInfo.rolename}}</span>
        </div>
        <div class="infodia-cell fl">
          <label>电话：</label>
          <span>{{userInfo.tel}}</span>
        </div>
        <div class="password fl">
          <span>原始密码:</span>
          <input v-model="originalPassword" />
        </div>
        <div class="password fl">
          <span>修改密码:</span>
          <input v-model="changePassword" />
        </div>
        <div class="password fl">
          <span>确认密码:</span>
          <input v-model="confirmPassword" />
        </div>
        <div class="dialog_footer fl">
          <el-button class="aa" @click="Close">取 消</el-button>
          <el-button class="aa" type="primary" @click="ChangePassword">确 定</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
//  import itemfileLoader from "../../components/commomUploader/fileLoader.vue"
import { mapState, mapMutations } from "vuex";
import { dinnerGetunreadmsg, modifypassword } from "@/apis/api";
import navHead from "./nav-head.vue";
const Max_Interval = 30
export default {
  data() {

    return {
      isTrue: false,
      originalPassword: "", //原始密码
      changePassword: "", //修改密码
      confirmPassword: "", //确认密码
      userinfoVisible: false, //控制用户信息弹窗显示
      //           userInfo:'',
      // alarmLength: 0,
      websock: null,
      // wsUrl: "ws://10.10.1.10:8010/irriproject/gprsdata/",
      wsUrl: window.WS_URL,
      audio: null,
      speech: null,
      count: 0,
      alarmList: [],
      isFirstConfirm: true,
      alarmListX_pre:[],
      curText:'',
      timer:{},
      timer_timeout:{},
      lastAlarm:{},
      curAlarm:{},
      isFirst:true,
      speektextpath:'',
      isPlaying : false,
      isAutoplay : true,
    };
  },

  components: {
    // itemfileLoader
    "nav-head": navHead
  },
  methods: {
    ...mapMutations(["CHANGEUSERINFO", "changeAlarmListX"]),

    guid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      );
    },
    leave() {
      //      	this.isTrue=false
    },
    enter() {
      //      	this.isTrue=true
    },
    exitSys() {
      this.CHANGEUSERINFO(null);
      this.$router.push({ path: "/login" });
      sessionStorage.clear();
    },
    ChangePassword() {
      if (this.originalPassword == "") {
        this.$message({
          message: "原始密码不能为空！",
          type: "warning"
        });
      } else if (this.changePassword == "") {
        this.$message({
          message: "修改密码不能为空！",
          type: "warning"
        });
      } else if (this.confirmPassword == "") {
        this.$message({
          message: "确认密码不能为空！",
          type: "warning"
        });
      } else if (this.confirmPassword != this.changePassword) {
        this.$message({
          message: "修改密码与确认密码不一致",
          type: "warning"
        });
      } else {
        let params = {};
        params.uuid = this.userInfo.uuid;
        params.oldpassword = this.originalPassword;
        params.newpassword = this.changePassword;
        modifypassword(params).then(res => {
          if (res.code == 1) {
            this.$message({
              message: "修改成功",
              type: "success"
            });
            this.originalPassword = "";
            this.changePassword = "";
            this.confirmPassword = "";
            this.userinfoVisible = false;
          } else {
            this.$message({
              message: "修改失败",
              type: "warning"
            });
          }
        });
      }
    },
    Close() {
      this.originalPassword = "";
      this.changePassword = "";
      this.confirmPassword = "";
      this.userinfoVisible = false;
    },
    showAlarm() {
      if (this.$route.name === "home") {
        this.$bus.$emit("tableOpened", "true");
      }
    },

    // 将警报声换成语音播报--20210716
    initSpeak() {
      this.speech = new SpeechSynthesisUtterance();
      this.speech.volume = 1
      this.speech.pitch = 1

    },
    getCxqk(zssw,swbjjjzsx,swbjjjzxx) {
      let cxqk = '';
      let cxqkValue = 0;
      if(zssw >= swbjjjzsx){
        if(zssw <= swbjjjzxx){
          cxqk = "超上限、超下限";
          cxqkValue = swbjjjzxx - zssw
        }else{
          cxqk = "超上限";
          cxqkValue = zssw - swbjjjzxx
        }
      }else if(zssw <= swbjjjzxx){
        cxqk = "超下限";
        cxqkValue = swbjjjzxx - zssw
      }
      return cxqk + cxqkValue.toFixed(2) + '米';
    },

    getCurAlarm(){
      if(JSON.stringify(this.curAlarm)==='{}'){
        this.curAlarm = this.alarmListX_pre[0]
      }else{
        let uuidList = this.alarmListX_pre.map(item=>{return item.uuid})
        if(this.curAlarm){
          let curIndex = uuidList.indexOf(this.curAlarm.uuid)
          if(curIndex === uuidList.length-1){
            this.curAlarm = this.alarmListX_pre[0]
          }else{
            this.curAlarm = this.alarmListX_pre[curIndex+1]
          }
        }else{
          this.curAlarm = this.alarmListX_pre[0]
        }

      }
    },

    indexInObjList(A,objList,key){
      let list = objList.map(item=>{return item[key]})
      return list.indexOf(A[key])
    },
    // 监听数据列表（alarmListX）的变化，更新播放列表（alarmListX_pre）
    handleAlarmListXChange(){
      if(this.alarmListX_pre.length===0){
        this.alarmListX_pre = this.alarmListX.concat([])
      }else{
        for(let i = 0; i < this.alarmListX_pre.length; i++){
          let index = this.indexInObjList(this.alarmListX_pre[i],this.alarmListX,'uuid')
          if(index === -1){
            this.alarmListX_pre.splice(i,1)
          }
        }
        for(let i = 0; i < this.alarmListX.length; i++){
          let index = this.indexInObjList(this.alarmListX[i],this.alarmListX_pre,'uuid')
          if(index === -1){
            this.alarmListX_pre.push(this.alarmListX[i])
          }
        }
      }
      // 在首次返回数据时启动定时器
      if(this.isFirst){
        this.timer = this.setIntervalImmediately(this.speak,Max_Interval*1000)
        this.isFirst = false
      }
    },
    // 播放 ---speechSynthesis
    // speak(){
    //   if(this.alarmListX_pre.length>0){
    //     console.log('speak')
    //     this.getCurAlarm()
    //     let cxqk = this.getCxqk(this.curAlarm.zssw,this.curAlarm.swbjjjzsx,this.curAlarm.swbjjjzxx)
    //     // let text = this.curAlarm.bjcftime+this.curAlarm.fynm + this.curAlarm.stnm + ',' + cxqk
    //     let text = this.curAlarm.bjcftime + this.curAlarm.fynm + this.curAlarm.stnm + cxqk
    //     // let text = this.curAlarm.bjcftime
    //     text = text.replaceAll('干','赣')
    //     this.speech.text = text
    //     // 每条数据播放三遍
    //     for(let i = 0; i < 3; i++){
    //       this.timer_timeout[i] = setTimeout(()=>{
    //         // console.log(this.speech.text,'this.speech.text')
    //         // console.log(speechSynthesis.getVoices(),'getVoices()')
    //         speechSynthesis.speak(this.speech)
    //       },Max_Interval/3 * i * 1000)
    //     }
    //   }
    // },

    // 播放 ---audio
    speak(){
      this.getCurAlarm()
      // 'C-'
      // let speektextpath = this.curAlarm.speektextpath.replace('speektextfile/','speektextfile/C-')

      if(this.curAlarm){
        let speektextpath = this.curAlarm.speektextpath
        console.log(speektextpath,'-------1')
        this.audio = new Audio(speektextpath);
        if(this.alarmListX_pre.length > 0){
          let promise = this.audio.play()
          let _this = this
          if(promise !== undefined) {
            promise.then(() => {
              console.log('Audio is playing.')
            }).catch(error => {
              console.log(error);
              // 再试一次
              _this.audio = new Audio(speektextpath);
              setTimeout(()=>{
                _this.audio.play()
              },2000)
            });
          }
        }else{
          this.audio.pause();
        }
      }
    },

    // 定时器立即播放
    setIntervalImmediately(func, interval){
      func()
      return setInterval(func, interval)
    },

    end(){
      console.log('end')
    },
     // 暂停
    pause() {
      speechSynthesis.pause()
    },
    // 继续播放
    resume() {
      speechSynthesis.resume()
    },
    // 取消播放
    cancel() {
      speechSynthesis.cancel()
      for(let i=0; i < 20; i++){
        if(this.timer_timeout&&this.timer_timeout[i]){
          clearTimeout(this.timer_timeout[i])
        }
      }
    },

    initWebSocket() {
      //初始化weosocket
      this.wsUrl = this.wsUrl + this.guid();
      this.websock = new WebSocket(this.wsUrl);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      //   let actions = { test: "12345" };
      //   this.websocketsend(JSON.stringify(actions));
    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) {
      //数据接收
      let redata = null;
      if (e.data.indexOf("success") == -1) {
        redata = JSON.parse(e.data);
        let data = redata.data.filter(item => {
          return item.useridlist.indexOf(this.userInfo.uuid) > -1
        })
        this.alarmList = data;
        if(this.alarmList.length > 0){
          this.showAlarm()
        }
        this.changeAlarmListX(this.alarmList);
        this.$bus.$emit("highlight", this.alarmList);
      }
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
    websocketclose(e) {
      //关闭
    }
  },
  watch: {
    alarmListX() {
      this.handleAlarmListXChange()
    }
  },
  created() {
    sessionStorage.setItem("regioncode", this.userInfo.regioncode + "");
    sessionStorage.setItem("userid", this.userInfo.userid);
    sessionStorage.setItem("username", this.userInfo.name);
  },
  computed: {
    ...mapState(["userInfo", "sysMenulist", "alarmListX"])
  },
  mounted() {
    // 初始化语音播放
    this.initSpeak();
    this.initWebSocket();

    // 监听删除正在播放的语音
    let _this = this
    this.$bus.$on("delAlarm", e => {
      console.log(_this.curAlarm.uuid,'_this.curAlarm.uuid')
      if(JSON.stringify(_this.curAlarm)!=='{}'&&e.uuid===_this.curAlarm.uuid){
        _this.audio.pause()
        let index = _this.indexInObjList(e,_this.alarmListX_pre,'uuid')
        if(index > 0){
          _this.curAlarm = _this.alarmListX_pre[index - 1]
        }else{
          _this.curAlarm = _this.alarmListX_pre[_this.alarmListX_pre.length - 1]
        }
      }
    });

    if (this.isFirstConfirm&&this.$route.name!=='wateralarm') {
      this.$alert("系统将自动进入报警监测状态", "温馨提示", {
        confirmButtonText: "知道了",
        callback: action => {}
      });
      this.isFirstConfirm = false;
    }



  },
  destroyed() {
    console.log('destroyed')
    if(this.timer){
      clearInterval(this.timer)
    }
    for(let i=0; i < 20; i++){
      if(this.timer_timeout&&this.timer_timeout[i]){
        clearTimeout(this.timer_timeout[i])
      }
    }
    this.websock.close(); //离开路由之后断开websocket连接
  }
};
</script>
<style lang='less' scoped>
.head-wrap {
  height: 75px;
  /*background-color: darkseagreen;*/
  background-image: url(../../../static/images/head/header-背景.png);
  /*border-bottom: 2px solid rgba(51, 140, 224, 1);*/
  position: relative;
  .sys-title {
    width: 400px;
    height: 44px;
    display: block;
    margin: 17px 10px 0 10px;
  }
  .head-cell {
    width: 100px;
    height: 100%;
    position: relative;
    color: #fff;
    /*margin-right: 20px;*/
    /*padding: 0 6px;*/
    cursor: pointer;
    /*&:hover {
                background-color: #2659BC;
            }*/
    img {
      width: 25px;
      height: 25px;
      position: absolute;
      left: 0;
      right: 0;
      top: 13px;
      margin: 0 auto;
    }
    .head-text {
      width: 100px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      font-size: 13px;
      position: absolute;
      left: 0;
      right: 0;
      top: 43px;
      margin: 0 auto;
    }
    .show-num {
      position: absolute;
      top: 25px;
      left: 30px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 12px;
      // margin: 3px;
      border-radius: 50%;
      background-color: red;
    }
  }
  .head-cells {
    width: 40px;
    height: 100%;
    position: relative;
    color: #fff;
    /*margin-right: 20px;*/
    /*padding: 0 6px;*/
    cursor: pointer;
    /*&:hover {
                background-color: #2659BC;
            }*/
    img {
      width: 25px;
      height: 25px;
      position: absolute;
      left: 0;
      right: 0;
      top: 13px;
      margin: 0 auto;
    }
    .head-text {
      width: 40px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      font-size: 13px;
      position: absolute;
      left: 0;
      right: 0;
      top: 43px;
      margin: 0 auto;
    }

    :global(.el-badge__content.is-fixed) {
      top: -24px;
      right: -18px;
    }
    .show-num {
      position: absolute;
      top: 25px;
      left: 30px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 12px;
      // margin: 3px;
      border-radius: 50%;
      background-color: red;
    }
  }
}

.infodia-cell {
  width: 50%;
  height: 30px;
  margin-top: 5px;
  font-size: 16px;
  line-height: 30px;
  label {
    display: inline-block;
    text-align: right;
    width: 30%;
  }
  span {
    display: inline-block;
    width: 67%;
  }
}
.password {
  width: 100%;
  height: 30px;
  margin: 5px 0;
  text-align: center;
  span {
    width: 50px;
    line-height: 30px;
    font-size: 16px;
    margin-right: 10px;
  }
  input {
    width: 250px;
    height: 30px;
  }
}

.el-dialog__title {
  color: #ffffff;
}
.dialog_footer {
  width: 100%;
  height: 30px;
  margin: 20px 0;
  .aa {
    float: right;
    margin-right: 20px;
  }
}
.choose_information {
  /*display: none;*/
  position: absolute;
  top: 70px;
  right: 10px;
  z-index: 30100;
  width: 130px;
  padding-top: 2px;
  ul {
    background-color: #fff;
    border-radius: 5px;
    /*z-index: 3000000;*/
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border: 1px solid #e3e3e3;
    li {
      height: 30px;
      cursor: pointer;
      line-height: 30px;
      text-align: center;
      &:hover,
      &.subactive {
        background-color: #306ac4;
        color: #fff;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/mainInterface/head.vue